<ng-template [ngIf]="loaded && !isClassroomMain">
  <app-user-widget [user]="teacher"></app-user-widget>
</ng-template>
